import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTableModule } from '@angular/material/table';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTabsModule } from '@angular/material/tabs';

import { HttpTokenInterceptor } from './providers';
import { TextEllipsisPipe } from './pipes/text-ellipsis.pipe';

import {
	WidgetComponent,
	PreviewDialogComponent,
	ConfirmDialogComponent,
	SuccessConfirmationComponent,
	VideoPlayerComponent,
	DownloadAppBannerDesktopComponent,
	DownloadAppComponent,
	DownloadAppBannerMobileComponent,
} from 'app/shared/components';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { ImageTextComponent } from './components/image-text/image-text.component';
import SpinnerComponent from './components/spinner/spinner.component';
import { IconsModule } from 'app/icons/icons.module';

// Modules
const MatModules = [
	MatIconModule,
	MatCardModule,
	MatIconModule,
	MatListModule,
	MatInputModule,
	MatButtonModule,
	MatDividerModule,
	MatSnackBarModule,
	MatFormFieldModule,
	MatInputModule,
	MatRippleModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTableModule,
	MatToolbarModule,
	MatSidenavModule,
	MatExpansionModule,
	MatGridListModule,
	MatTabsModule,
];

// Components
const components = [
	WidgetComponent,
	TextEllipsisPipe,
	VideoPlayerComponent,
	ConfirmDialogComponent,
	PreviewDialogComponent,
	SuccessConfirmationComponent,
	ImageTextComponent,
	SpinnerComponent,
	DownloadAppBannerDesktopComponent,
	DownloadAppComponent,
	DownloadAppBannerMobileComponent,
];

@NgModule({
	imports: [
		...MatModules,
		FormsModule,
		CommonModule,
		FlexLayoutModule,
		YouTubePlayerModule,
		ReactiveFormsModule,
		IconsModule,
	],
	declarations: [...components],
	exports: [
		...MatModules,
		...components,
		FormsModule,
		CommonModule,
		FlexLayoutModule,
		ReactiveFormsModule,
	],
	providers: [
		CookieService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpTokenInterceptor,
			multi: true,
		},
	],
})
export class SharedModule {}
